import React, { useMemo } from "react";
import { chunk } from "lodash";
import { useAssetTypeIdentifiers } from "../../common/hooks";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import styles from "./styles";

import {
    Grid,
    Divider,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
} from "@mui/material/";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {
    useTypesListAssetTypes,
    useAssetTypeAttributes,
    useTypesListMake,
} from "../../common/hooks";

/**
 * Audit Asset Attributes Component
 */
export default ({ asset, expandDetails, hdlExpandDetails }) => {
    const classes = makeStyles(styles)();
    const { t } = useTranslation();
    const { assetCore, assetAttributes } = asset;

    const identifiers = useAssetTypeIdentifiers(assetCore.type);
    const type = useTypesListAssetTypes(assetCore.type);
    const make = useTypesListMake(assetCore.make);
    const attributes = useAssetTypeAttributes(assetCore.type);

    const rows = useMemo(() => chunk(assetAttributes, 2), [assetAttributes]);

    /** If the value of the string is none then convert
     * translate it using the translation 
     */
    const convertNoneString = (str) => {
        if (str && str.toLowerCase() === "none") return t("none");
        if (str) return str;
        else return;
    };

    return (
        <Accordion
            elevation={0}
            expanded={expandDetails}
            onChange={() => hdlExpandDetails(!expandDetails)}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="summary-panel-content"
                id="summary-panel-header"
                className={classes.accordionSummary}
            >
                <Typography>{`${t(identifiers.identifier1)}: ${
                    assetCore.identifier1
                }`}</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetails}>
                <Grid container>
                    {Boolean(assetCore.identifier2) && (
                        <>
                            <Grid item xs={6}>
                                <Typography
                                    variant="subtitle1"
                                    component="div"
                                    className={classes.typoBold}
                                >
                                    {t(identifiers.identifier2)}
                                </Typography>
                            </Grid>
                            <Grid>
                                <Typography variant="subtitle1" component="div">
                                    {assetCore.identifier2}
                                </Typography>
                            </Grid>
                        </>
                    )}

                    {Boolean(
                        assetCore.identifier3 || assetCore.identifier4
                    ) && (
                        <>
                            {Boolean(assetCore.identifier3) && (
                                <>
                                    <Grid item xs={6}>
                                        <Typography
                                            variant="subtitle1"
                                            component="div"
                                            className={classes.typoBold}
                                        >
                                            {t(identifiers.identifier3)}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="subtitle1">
                                            {assetCore.identifier3}
                                        </Typography>
                                    </Grid>
                                </>
                            )}
                            {Boolean(assetCore.identifier4) && (
                                <>
                                    <Grid item xs={6}>
                                        <Typography
                                            variant="subtitle1"
                                            component="div"
                                            className={classes.typoBold}
                                        >
                                            {t(identifiers.identifier4)}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="subtitle1">
                                            {assetCore.identifier4}
                                        </Typography>
                                    </Grid>
                                </>
                            )}
                        </>
                    )}
                    <>
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle1"
                                component="div"
                                className={classes.typoBold}
                            >
                                {t("make_one")}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="subtitle1">
                                {make.name}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle1"
                                component="div"
                                className={classes.typoBold}
                            >
                                {t("type")}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="subtitle1">
                                {type.name}
                            </Typography>
                        </Grid>
                    </>
                    <>
                        {rows.map(([first, second], index) => (
                            <React.Fragment key={index}>
                                {first && (
                                    <>
                                        <Grid item xs={6}>
                                            <Typography
                                                variant="subtitle1"
                                                component="div"
                                                className={classes.typoBold}
                                            >
                                                {attributes[first.attribute]}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle1">
                                                {convertNoneString(
                                                    first.value
                                                ) || "\u2014"}
                                            </Typography>
                                        </Grid>
                                    </>
                                )}
                                {second && (
                                    <>
                                        <Grid item xs={6}>
                                            <Typography
                                                variant="subtitle1"
                                                component="div"
                                                className={classes.typoBold}
                                            >
                                                {attributes[second.attribute]}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle1">
                                                {convertNoneString(
                                                    second.value
                                                ) || "\u2014"}
                                            </Typography>
                                        </Grid>
                                    </>
                                )}
                            </React.Fragment>
                        ))}
                    </>
                </Grid>
                <Divider className={classes.divider} />
            </AccordionDetails>
        </Accordion>
    );
};
